import { api } from "../../services/axios";
import { useCallback, useEffect, useState } from "react";

export const useAnnouncements = () => {
  const [anouncements, setAnouncements] = useState([]);
  const [anouncementsLoading, setAnouncementsLoading] = useState(true);

  const [anouncementContent, setAnouncementContent] = useState([]);
  const [anouncementContentLoading, setAnouncementContentLoading] =
    useState(true);

  const handleGetAnnouncements = useCallback(async () => {
    try {
      setAnouncementsLoading(true);
      const { data: anouncementsResponse } = await api.get(
        "/portalCliente/comunicados"
      );

      setAnouncements(anouncementsResponse);
    } catch (error) {
      console.error("Error fetching anouncements:", error);
    } finally {
      setAnouncementsLoading(false);
    }
  }, []);

  const handleGetAnnouncement = useCallback(
    async ({ selectedAnnoucements, title }) => {
      try {
        setAnouncementContentLoading(true);
        const { data: anouncementsContentResponse } = await api.get(
          "/portalCliente/comunicado",
          {
            params: {
              id: selectedAnnoucements,
            },
          }
        );

        const data = anouncementsContentResponse[0];
        data.title = title;
        setAnouncementContent(data);
      } catch (error) {
        console.error("Error fetching anouncement:", error);
      } finally {
        setAnouncementContentLoading(false);
      }
    },
    []
  );

  useEffect(() => {
    handleGetAnnouncements();
  }, [handleGetAnnouncements]);

  return {
    anouncements,
    anouncementsLoading,
    handleGetAnnouncement,
    setAnouncementContent,
    anouncementContent,
    anouncementContentLoading,
  };
};
